import { Box, TextField } from "@mui/material";

const TextboxResponse = ({ question, selectChoice, selections, themeColors }) => {
    return (
        <Box sx={{ mb: 5 }}>
            <TextField
                readOnly={true}
                value={selections[question.id] || ""}
                variant="outlined"
                style={{ borderRadius: 5 }}
            />
        </Box>
    );
};
export default TextboxResponse;
